const fitterLogEn = {
	fitterLogTable: 'Fitter Log',
	timestamp: 'Timestamp',
	tag: 'Tag',
	objective: 'Objective',
	state: 'State',
	name: 'Name',
	fitterLogEditForm: 'Fitter Log',
	basic: 'Basic',
	table_name: 'Table Name',
	description: 'Description',
	fields: 'Fields',
	type: 'Type'
};

export default fitterLogEn;
